<script setup lang="ts">
const CLOSE_IMG = 'https://resources1.interface003.com/web30/2026/06/24/79597aa8-cc8a-4b81-a642-c0579965981e.png'
/** 组件入参，控制视频弹窗显隐和播放资源。 */
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    address?: string
    poster?: string
  }>(),
  {
    address: '',
    poster: '',
  },
)

/** 向父组件同步弹窗显示状态。 */
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

/** video DOM 引用，用于控制播放和重置进度。 */
const videoplay = ref<HTMLVideoElement | null>(null)

/** 双向绑定后的弹窗显示状态。 */
const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

/** 当前视频地址，缺失时回退空字符串。 */
const videoAddress = computed(() => props.address || '')

/** 弹窗开关时同步处理视频播放、暂停和进度重置。 */
watch(
  () => visible.value,
  async (isVisible) => {
    await nextTick()

    if (!videoplay.value) {
      return
    }

    if (!isVisible) {
      videoplay.value.pause()
      videoplay.value.currentTime = 0
      return
    }

    try {
      await videoplay.value.play()
    } catch {
      // 浏览器拦截自动播放时保持静默
    }
  },
)

/** 关闭视频弹窗。 */
function closeDialog() {
  visible.value = false
}
</script>

<template>
  <ClientOnly>
    <ElDialog
      v-model="visible"
      width="1000px"
      class="xy-fixed !m-0 !rounded-[32px] !bg-[transparent] !p-0"
      body-class="!p-0 !bg-[transparent]"
      :close-on-click-modal="false"
      header-class="hidden"
    >
      <div class="relative">
        <video
          id="video"
          ref="videoplay"
          :src="videoAddress"
          :poster="poster"
          type="video/mp4"
          class="block h-[568px] w-full !rounded-[32px] bg-black object-cover"
          autoplay
          controls="controls"
          loop="-1"
          preload
          muted
          controlslist="nodownload noplaybackrate"
          disablePictureInPicture
          noplaybackrate
        ></video>

        <button
          type="button"
          class="absolute top-[32px] right-[32px] z-[2] flex size-[32px] cursor-pointer items-center justify-center rounded-full bg-[rgba(5,12,31,0.46)] hover:bg-[rgba(5,12,31,0.62)] rtl:right-auto rtl:left-[32px]"
          @click="closeDialog"
        >
          <CommonImage class="size-[12px]" :src="CLOSE_IMG" alt="close" />
        </button>
      </div>
    </ElDialog>
  </ClientOnly>
</template>
